import { Link } from 'react-router-dom';
import { Button } from '@/components/ui';
import { usePageHelpPopover } from '@/components/tour/PageHelpPopover';
import { buildSupportUrl } from '@/utils/supportUrl';

interface DashboardPageHelpProps {
  title: string;
  description: string;
  academyId?: string;
  onReplayTour: () => void;
}

export function DashboardPageHelp({
  title,
  description,
  academyId,
  onReplayTour,
}: DashboardPageHelpProps) {
  const closePageHelp = usePageHelpPopover();
  const supportHref = buildSupportUrl({
    type: 'general',
    subject: 'Help with my dashboard',
    academyId,
  });

  const handleReplayTour = () => {
    closePageHelp();
    onReplayTour();
  };

  const handleSupportClick = () => {
    closePageHelp();
  };

  return (
    <div className="space-y-4 text-sm text-muted-foreground">
      <div>
        <h3 className="mb-2 text-sm font-semibold text-foreground">{title}</h3>
        <p>{description}</p>
      </div>
      <div className="flex flex-wrap gap-2 border-t border-border pt-3">
        <Button type="button" variant="outline" size="sm" onClick={handleReplayTour}>
          Start tour again
        </Button>
        <Button asChild variant="outline" size="sm">
          <Link to={supportHref} onClick={handleSupportClick}>
            Contact support
          </Link>
        </Button>
      </div>
    </div>
  );
}
